import { dateFormat } from '@/helpers/common';
const filters = {
  dateFormat: (date, format = 'YY-mm-dd HH:MM:SS') => dateFormat(format, date),
  hidephonecenter(value) {
    let reg = /^(\d{3})\d{4}(\d{4})$/;
    return value.replace(reg, "$1****$2");
  },
};

export { filters };